<div class="col formscreen">
    <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
    @if(checkProvided === false) {
        <div class="col headline">
            <h1>Set new password</h1>
            <span
                >Your reset link will be checked. If it is valid, you can set a new password. Please wait while we verify your link.</span
            >
            <div class="w100 col justify-center align-center">
                       <a href="/login">Got to Login.</a>
            </div>
        </div>
    }@else{
        @if(isValid){
        <form class="loginform" [formGroup]="setpwForm" (ngSubmit)="onSubmit()">
            <div class="col headline">
                <h1>Set new password</h1>
                <span
                    >Set a new password for your account. After that you are
                    directly logged in.</span
                >
            </div>
            <div class="col withlink tiny">
                <rr-input
                    label="Enter your password"
                    type="password"
                    [verifyPassword]="true"
                    [required]="true"
                    formControlName="password"
                ></rr-input>
                <a href="/login">Log in again?</a>
            </div>
            <rr-btn type="Primary" (btnClick)="onSubmit()"
                >Set Password & Log in</rr-btn
            >
        </form>
        }@else{
            <div class="col headline">
                <h1>Set new password</h1>
                <span
                    >Your reset link is invalid. Please request a new one.</span
                >
            </div>
        }

    }
</div>
<div class="rightsideimage"></div>
@if(hidespinner === false) {
    <rr-spinner></rr-spinner>
}
